
import { Component, Vue } from 'vue-property-decorator';
import {
    getMissingCycleTimes,
    onMissingCycleTimesChanged,
    MissingCycleTimeItem,
} from '@/libs/tpm-analytics/core/missing-cycle-times';

@Component({ name: 'MissingCycleTimesAlert' })
export default class MissingCycleTimesAlert extends Vue {
    items: MissingCycleTimeItem[] = [];
    unsub: null | (() => void) = null;

    created() {
        this.items = getMissingCycleTimes();
        this.unsub = onMissingCycleTimesChanged(() => {
            this.items = getMissingCycleTimes();
        });
    }

    destroyed() {
        const u = this.unsub;
        if (typeof u === 'function') {
            try {
                u();
            } catch {
                /* ignore */
            }
        }
    }

    get itemsLine(): string {
        return (this.items || [])
            .map((x: MissingCycleTimeItem) => x.productCode || x.productId)
            .filter((v: string | null | undefined) => !!v)
            .join(', ');
    }

    getWorkplaceCodes(item: MissingCycleTimeItem): string[] {
        // Vrací kódy pracovišť
        if (item.workplaceCodes && item.workplaceCodes.length > 0) {
            return item.workplaceCodes.filter((code): code is string => !!code);
        }
        return [];
    }

    async copyToClipboard(): Promise<void> {
        const codes = (this.items || [])
            .map((x: MissingCycleTimeItem) => x.productCode || x.productId)
            .filter((v: string | null | undefined) => !!v)
            .join('\n');

        try {
            await navigator.clipboard.writeText(codes);
            this.$root.$emit('toast', {
                type: 'success',
                text: this.$t('common.copySuccess'),
            });
        } catch (error) {
            // Fallback pro starší prohlížeče
            const textArea = document.createElement('textarea');
            textArea.value = codes;
            textArea.style.position = 'fixed';
            textArea.style.left = '-999999px';
            document.body.appendChild(textArea);
            textArea.select();
            try {
                document.execCommand('copy');
                this.$root.$emit('toast', {
                    type: 'success',
                    text: this.$t('common.copySuccess'),
                });
            } catch (err) {
                this.$root.$emit('toast', {
                    type: 'error',
                    text: this.$t('common.error'),
                });
            }
            document.body.removeChild(textArea);
        }
    }
}
